module.exports = ("1.5.9");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@dp/knb/compiled/common/version.js
// module id = ROT1
// module chunks = 0